// Alert + Toast chrome strings — EN + TR.
//
// Wave-1 Day 3 wiring. Covers chrome strings (title / empty / open action /
// close aria-label) for:
//   - AlertBanner (header critical-severity strip)
//   - AlertCenter (warning + info widget)
//   - Toaster (ui primitive — only close aria-label)
//
// NOTE: alert title + description data are MSW payload-driven (backend-owned
// content; not i18n target). Only chrome locale-aware.

import type { LocalizedDict } from '../index'

type AlertStrings = {
  title: string
  empty: string
  openAction: string
  closeAriaLabel: string
}

export const alertI18n: LocalizedDict<AlertStrings> = {
  en: {
    title: 'Alerts',
    empty: 'No pending alerts.',
    openAction: 'Open',
    closeAriaLabel: 'Close',
  },
  tr: {
    title: 'Uyarılar',
    empty: 'Bekleyen uyarı yok.',
    openAction: 'Aç',
    closeAriaLabel: 'Kapat',
  },
}
